var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"notify-btn",class:[
  _vm.btn ? 'notify-btn-' + _vm.btn : '',
  _vm.size ? 'notify-btn-' + _vm.size : '',
  {
    'disabled': _vm.disabled,
  }
],attrs:{"type":_vm.type,"name":"button"},on:{"click":_vm.clickon}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }